// extracted by mini-css-extract-plugin
export default {"wrapper":"a2-z","availablePromoMessagesLabel":"b2-z","promoMessageList":"c2-z","promoMessage":"d2-z","appliedPromoMessage":"e2-z","promoMessageAmount":"f2-z"};